export const GITLAB_EE_PLAN_TYPE = 'gitlab-ee-plan';
export const GITLAB_COM_PLAN_TYPE = 'gitlab-com-plan';
export const GITLAB_LEGACY_PLAN_TYPE = 'gitlab-legacy-plan';
export const GITLAB_SUBSCRIPTION_TYPES = [
  GITLAB_EE_PLAN_TYPE,
  GITLAB_COM_PLAN_TYPE,
  GITLAB_LEGACY_PLAN_TYPE,
];

export const PLAN_TYPE = 'plan';
export const ADDON_PRODUCT_TYPE = 'addon-product';
export const DISCOUNT_PRODUCT_TYPE = 'discount';
export const GITLAB_CREDITS_PLAN_TYPE = 'gitlab_credits';
export const BASE_PRODUCT_PLAN_TYPE = 'base_product';
export const DUO_SELF_HOSTED_PLAN_TYPE = 'duo_self_hosted';

// API URLs
export const ORDERS_URL = '/orders/:order_id';
export const SUBSCRIPTIONS_URL = '/subscriptions';
export const AUTORENEW_SUBSCRIPTION_URL = '/subscriptions/:subscription_name/auto_renew/';
export const CHANGE_SUBSCRIPTION_URL = '/subscriptions/:subscription_name';

export const RENEW_SUBSCRIPTION_URL = '/subscriptions/:subscription_name/multi_product_renewal';
export const PREVIEW_UPGRADE_SUBSCRIPTION_URL =
  '/subscriptions/:subscription_name/upgrade/:plan_id/preview';
export const UPGRADE_SUBSCRIPTION_URL = '/subscriptions/:subscription_name/upgrade';
export const PAYMENT_METHODS_URL = '/payment_methods/:payment_method_id/check_default';
export const INVOICES_URL = '/invoices';

export const PRICING_URL = 'https://about.gitlab.com/pricing/';
export const FLEX_DOCS_URL = 'https://docs.gitlab.com/subscriptions/gitlab_flex/';
export const FLEX_SPEND_CAPS_DOCS_URL =
  'https://docs.gitlab.com/subscriptions/gitlab_flex/#spend-caps';
export const ADDONS_DOCS_URLS = 'https://docs.gitlab.com/subscriptions/gitlab_com/compute_minutes/';

export const ADD_SEATS_DESCRIPTION_MESSAGE = `This number must be %{owedSeats} (your owed seats) or more.`;

export const CHANGE_NAMESPACE_INFO_MESSAGE = `We can't transfer plan subscriptions to a group which already has a purchased plan.`;
export const ERROR_FETCHING_NAMESPACES_MESSAGE =
  'Could not fetch namespaces from GitLab.com. Please try again';
export const ERROR_GETTING_NAMESPACE_MESSAGE = 'Could not get namespace info for namespace';
export const ERROR_INACTIVE_SUBSCRIPTION_MESSAGE =
  "Your subscription can't be transferred because the selected namespace has an active subscription.";

export const COPY_ERROR_MESSAGE = 'An error occurred, please try again later.';
export const COPY_DEFAULT_TITLE = 'Click and copy to the clipboard.';
export const COPY_SUCCESSFUL_MESSAGE = 'Text successfully copied to the clipboard.';

export const EMPTY_PAGE_HEADLINE = 'You do not have any active subscriptions';
export const EMPTY_PAGE_SUBHEADLINE = 'Active subscriptions and add-ons will be shown here.';
export const EMPTY_PAGE_SUBHEADLINE_INVOICES_HISTORY =
  'To view your purchase history, go to the %{linkStart}Invoices page%{linkEnd}.';
export const BUY_SUBSCRIPTION_BUTTON_TEXT = 'Buy new subscription';
export const BUY_ADDON_BUTTON_TEXT = 'Buy compute minutes';

export const LICENSE_TYPES = {
  CLOUD: 'cloud',
  LEGACY: 'legacy',
};

export const COMMUNITY_PLANS_EDU_APPLICATION_LINK =
  'https://about.gitlab.com/solutions/education/join/#application';

export const COMMUNITY_PLANS_OSS_APPLICATION_LINK =
  'https://about.gitlab.com/solutions/open-source/join/#application';

export const UPGRADE_OR_ACTIVATE_MESSAGE =
  'Your subscription requires GitLab version %{version} or later. Learn how to %{upgradeLinkStart}upgrade your GitLab version%{upgradeLinkEnd} or how to %{activateLinkStart}activate your subscription%{activateLinkEnd}.';

export const LEGACY_LICENSE_MESSAGE =
  'Learn how to %{uploadLicenseLinkStart}upload your license%{uploadLicenseLinkEnd}.';

export const ACTIVATION_CODE_LABEL = 'Activation code';
export const LEGACY_LICENSE_ACTIVATION_LABEL = 'Legacy license';
export const ACTIVATE_SUBSCRIPTION_URL = 'https://docs.gitlab.com/administration/license/';
export const UPDATE_GITLAB_URL = 'https://docs.gitlab.com/update/';
export const UPLOAD_LICENSE_URL = 'https://docs.gitlab.com/administration/license_file/';
export const PROMO_CODE_INFO_LINK = 'https://about.gitlab.com/pricing/terms/';
export const INVALID_PROMO_CODE_ERROR_MESSAGE = 'Enter a valid coupon code.';
export const PROMO_CODE_PURCHASE_SUCCESS_MESSAGE = `Coupon has been applied to your purchase. See GitLab promotional %{linkStart}terms and conditions%{linkEnd}.`;
export const PROMO_CODE_QUANTITY_ERROR_MESSAGE = 'Add active users before adding a coupon.';
export const CHARGE_PROCESSING_TYPE = 'Charge';
export const DISCOUNT_PROCESSING_TYPE = 'Discount';
export const PROMO_CODE_ERROR_ATTRIBUTE = 'promo_code';
export const INVALID_PROMO_CODE_ERROR_CODE = 'INVALID_PROMO_CODE';

export const OPEN_SOURCE_PROGRAM_HANDBOOK_LINK =
  'https://handbook.gitlab.com/handbook/marketing/developer-relations/community-programs/open-source-program/#who-qualifies-for-the-gitlab-for-open-source-program';
export const OPEN_SOURCE_PROGRAM_AGREEMENT_LINK =
  'https://handbook.gitlab.com/handbook/legal/opensource-agreement';

// Common errors
export const MUST_BE_PROVIDED = '%{name} must be provided.';
export const MUST_BE_ACCEPTED = '%{name} must be accepted.';
export const COMMON_API_ERROR_MESSAGE = 'An error occurred, please try again later.';
